import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 40px 0;
  overflow: hidden;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  padding: 0 40px 80px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Content = styled.main`
  width: 100%;
  max-width: 680px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 40px;

  span {
    font-family: 'Avenir Next LT Pro Regular';
    font-size: 30px;
    margin-bottom: 10px;

    @media (max-width: 414px) {
      font-size: 16px;
    }
  }

  h1 {
    font-family: 'Avenir Next LT Pro Bold';
    font-size: 60px;

    @media (max-width: 414px) {
      font-size: 35px;
    }
  }

  p {
    font-size: 16px;
    line-height: 150%;
    margin-top: 20px;

    & + p {
      margin-top: 10px;
    }

    @media (max-width: 414px) {
      margin-top: 20px;
      font-size: 16px;
    }
  }

  a {
    margin-top: 50px;
  }

  section {
    margin: 40px 0 80px;

    span {
      margin-bottom: 30px;
      display: block;
      font-size: 16px;
    }

    .techs {
      display: flex;
      list-style: none;
      justify-content: space-between;
      max-width: 70%;

      @media (max-width: 414px) {
        max-width: 100%;
      }

      li {
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
          margin-top: 14px;
          display: block;
          font-size: 13px;
          color: #ddd;
        }

        @media (max-width: 414px) {
          img {
            width: 40px;
          }

          p {
            font-size: 10px;
          }
        }
      }
    }
  }

  .footer {
    display: flex;

    @media (max-width: 414px) {
      flex-direction: column;
    }

    div {
      border-left: 3px solid #fff;
      padding-left: 30px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 50px;

      @media (max-width: 414px) {
        margin-right: 0;

        & + div {
          margin-top: 30px;
        }
      }

      h4 {
        font-family: 'Avenir Next LT Pro Bold';
        font-size: 17px;
        line-height: 18px;
        margin-bottom: 12px;
      }

      ul {
        display: flex;
        a {
          text-decoration: none;
          color: #fff;
          margin-right: 20px;
          margin-top: 0;

          &:after {
            content: '';
            display: block;
            height: 2px;
            width: 70%;
            background: #fff;
            transition: all ease-in-out 0.3s;
          }

          &:hover {
            ::after {
              width: 100%;
            }
          }
        }
      }

      p {
        margin-top: 0;
        color: #fff;
      }
    }
  }
`;
